module.exports = __webpack_public_path__ + "static/media/iconCantineMenuAcive.cfb0915d.svg";